import { TakeOffStore } from "modules/takeOff/TakeOffStore";
import { default as firebase, firestore } from "common/Firebase";
import { DevelopmentStore } from "modules/development/DevelopmentStore";
import { TakeOffItem } from "modules/takeOff/models/TakeOffItem";
import {
  createTakeOffFormatedItemFromDocument,
  TakeOffFormatedItem,
} from "modules/takeOff/models/TakeOffFormatedItem";
import { ModelMapFilter } from "modules/modelMap/models/ModelMapFilter";
import { FirebaseDocument } from "common/models/FirebaseDocument";
import { ModelMap } from "modules/modelMap/models/ModelMap";
import * as _ from "lodash";
import { ProjectStore } from "modules/project/ProjectStore";
import { ModelMapStore } from "modules/modelMap/ModelMapStore";
import { CalculateWBSService } from "modules/WBS/CalculateWBSService";
import { WBSStore } from "modules/WBS/WBSStore";
import { WBSPropertiesStore } from "modules/WBS/WBSPropertiesStore";
import { WBSModels } from "modules/WBS/WBSModels";
import { ToolbarStore } from "modules/WBS/ToolbarStore";
import { LoginStore } from "modules/login/LoginStore";
import i18n from "i18n";
import { ERowType } from "common/enums";
import { extractNumberFromText } from "utils/MathUtils";
import axios from "axios";
import { roundBy, sum, times } from "utils/DecimalUtils";

class Service {
  /**
   * Esta função obtém os dados do takeOff do model-map da memória, caso não tenha,
   * faz consulta no banco de dados.
   */
  async fetchTakeOffList(modelMap: FirebaseDocument<ModelMap>): Promise<void> {
    let itemsArray = new Array<TakeOffItem>();
    let columnsArray = new Array();
    let groupData = new Array();

    if (
      TakeOffStore.groupDataModelMap == undefined ||
      TakeOffStore.groupDataModelMap[modelMap.id] == undefined
    ) {
      groupData = await this.groupModelMapDataFromFiles(modelMap);
      if (TakeOffStore.groupDataModelMap == undefined) {
        TakeOffStore.groupDataModelMap = [];
      }
      TakeOffStore.groupDataModelMap[modelMap.id] = groupData;
    } else {
      groupData = TakeOffStore.groupDataModelMap[modelMap.id];
    }
    if (modelMap.data.fields.length > 0) {
      columnsArray = modelMap.data.fields;
    }

    let i = 0;
    for (let change of groupData) {
      let takeOffItem = this.setTakeOffItem(change, WBSStore.WBS.id);
      itemsArray.push(takeOffItem);
      TakeOffStore.listSelect.push({ rowId: i, selected: false });

      if (modelMap.data.fields.length === 0) {
        for (const prop of Object.keys(takeOffItem.properties))
          if (columnsArray.indexOf(prop) < 0) columnsArray.push(prop);

        if (modelMap.data.type === "MAT")
          for (const mat of modelMap.data.types) {
            if (columnsArray.indexOf(mat) < 0) columnsArray.unshift(mat);
          }
      }
      i++;
    }

    if (modelMap.data.fields.length === 0) modelMap.data.fields = columnsArray;
    TakeOffStore.takeOffModelMap = modelMap;

    this.loadTakeOffStoreCollections(itemsArray, columnsArray);
  }

  /**
   * Método responsável por efetuar as queries que recuperam as informações dos itens dos ifcs que devem ser apresentados no take off do model map
   */
  private async groupModelMapDataFromFiles(
    modelMap: FirebaseDocument<ModelMap>
  ) {
    TakeOffStore.setLoadingTakeOff(true);
    // Array responsável por concatenar as informações que serão devolvidas pelo método
    let groupData = new Array();
    TakeOffStore.setSearchElementOrMaterialLength(0);
    if (modelMap.data.files.length === 0) return groupData;

    for (const cat of modelMap.data.types) {
      let promises: any[] = [];
      TakeOffStore.setSearchElementOrMaterial(cat);
      for (const file of modelMap.data.files) {
        await sleep(1500);
        promises.push(
          axios.post(`${process.env.REACT_APP_GET_TAKEOFF_ITEMS}`, {
            developmentId: DevelopmentStore.developmentSelected.id,
            fileId: file,
            type: modelMap.data.type,
            categories: [cat],
          })
        );
      }
      await Promise.all(promises)
        .then((results) => {
          results.forEach((result) => {
            if (result && result.data && result.data.length) {
              let processedFiles =
                TakeOffStore.searchMaterialOrMaterialLength +
                result.data.length;
              TakeOffStore.setSearchElementOrMaterialLength(processedFiles);
              groupData = groupData.concat(result.data);
            }
          });
        })
        .catch((error) => console.error("Error on takeOff request", error));
    }

    // Retorna do método os dados agrupados pelas queries efetuadas
    TakeOffStore.setLoadingTakeOff(false);
    return groupData;
  }

  async fetchTakeOffFormatedItemsFromDataBase(
    modelMap?: FirebaseDocument<ModelMap>,
    getById?: string,
    callback?: (modelMapUid: string, list: TakeOffFormatedItem[]) => void
  ): Promise<void> {
    return new Promise((resolve: any) => {
      if (!modelMap && !getById) {
        resolve();
        return;
      }

      try {
        const modelId = getById ? getById : modelMap ? modelMap.id : "";
        LoginStore.clearTakeOffFormatedItemsSnapshot();
        LoginStore.takeOffFormatedItemsSnapshot = firebase
          .firestore()
          .collection("developments")
          .doc(DevelopmentStore.developmentId)
          .collection("takeOffFormatedItems")
          .where("modelMapId", "==", modelId)
          .onSnapshot((snapshot) => {
            const formatedList = snapshot.docs.map((doc: any) =>
              createTakeOffFormatedItemFromDocument(doc)
            );
            const ordernedList = formatedList.sort((a, b) =>
              a.listIndex < b.listIndex ? -1 : a.listIndex > b.listIndex ? 1 : 0
            );

            if (callback) callback(modelId, ordernedList);
          });
        resolve();
      } catch (e) {
        console.log(e);
        resolve();
      }
    });
  }

  async getordernedList(modelMapId) {
    let snapshot = await firebase
      .firestore()
      .collection("developments")
      .doc(DevelopmentStore.developmentId)
      .collection("takeOffFormatedItems")
      .where("modelMapId", "==", modelMapId)
      .get();

    let formatedList = snapshot.docs.map((doc: any) => {
      let data: any = doc.data();
      data.resultQuantity = Math.round(data.resultQuantity * 100) / 100;
      return new TakeOffFormatedItem(
        data.description,
        data.quantity,
        data.unit,
        data.isStage,
        data.index,
        data.parentIndex,
        data.listIndex,
        data.parentListIndex,
        data.descriptionArray,
        data.quantityArray,
        data.unitArray,
        data.resultQuantity,
        data.modelMapId
      );
    });

    return formatedList.sort((a, b) =>
      a.listIndex < b.listIndex ? -1 : a.listIndex > b.listIndex ? 1 : 0
    );
  }

  /**
   * Função executada para atualizar as informações de um model map na EAP
   */
  async updateTakeOffIntoWBS(
    modelMap: FirebaseDocument<ModelMap>
  ): Promise<void> {
    const rowsToCalc = WBSStore.dataTable.filter(
      (element) =>
        element.data.fromModelMap == modelMap.id &&
        element.data.modelMapFull === true &&
        element.data.rowType === ERowType.STAGE
    );
    let dados_ = new Array();
    for (let i = 0; i < rowsToCalc.length; i++) {
      dados_.push({
        description: rowsToCalc[i].data.description,
        total: rowsToCalc[i].data.total,
        totalBdi: rowsToCalc[i].data.totalBdi,
      });
    }
    TakeOffStore.statusModelmap = "Loading";

    let selectedRowIndex = WBSStore.selectedLine.data
      ? WBSStore.selectedLine.data.rowIndex
      : -1;
    let selectedParentStage = WBSStore.selectedLine.data
      ? WBSStore.selectedLine.data.parentStage
      : -1;

    let modelMapRowsOnlyQuantity = WBSStore.dataTable.filter(
      (dt) => dt.data.fromModelMap === modelMap.id && !dt.data.modelMapFull
    );

    let ordernedList = await this.getordernedList(modelMap.id);

    for (let i = 0; i < modelMapRowsOnlyQuantity.length; i++) {
      let qtd = modelMapRowsOnlyQuantity[i];
      let takeOffQuantity: any = qtd.data.takeOffQuantity;
      if (takeOffQuantity && takeOffQuantity[0]) {
        let idxOrderned = this.getTakeOffLineIndexByDescriptions(
          takeOffQuantity,
          ordernedList
        );
        if (idxOrderned > -1) {
          WBSStore.handleWBSTableChange(
            qtd,
            WBSStore.dataTable.findIndex((dt) => dt.id == qtd.id),
            "row",
            "quantity",
            ordernedList[idxOrderned].resultQuantity
          );
        } else {
          WBSStore.handleWBSTableChange(
            qtd,
            WBSStore.dataTable.findIndex((dt) => dt.id == qtd.id),
            "row",
            "quantity",
            0
          );
        }
      }
    }

    // Recupera as linhas de etapa do plano de custo que foram criadas pelo model map
    let modelMapRows = _.filter(WBSStore.dataTable, function (o) {
      return (
        o.data.fromModelMap === modelMap.id && o.data.rowType === ERowType.STAGE
      );
    });

    // Filtra apenas as primeiras linhas de cada model map
    let modelMapFilteredRows = modelMapRows.filter(
      (m) =>
        WBSStore.dataTable.findIndex(
          (dt) =>
            m.data.parentStage == -1 ||
            (dt.id == m.data.parentStage && !dt.data.fromModelMap)
        ) != -1
    );

    // Define flag para identificar atualizações efetuadas com sucesso
    let updateSuccessful = true;

    let toDelete: any = [];
    // Percorre cada inserção do model map na EAP
    for (const modelMapFirstRow of modelMapFilteredRows) {
      // Recupera o índice da etapa principal do model map na EAP
      // Efetua os mesmos tratamentos de inclusão de model map na EAP, para incluir acima do model map antigo a versão atualizada do mesmo
      try {
        let { rowType } = modelMapFirstRow.data;
        if (rowType !== ERowType.BLANK) {
          WBSStore.loadDatatableWithRightFormat(WBSStore.WBSRows);
          await WBSStore.setSelectedLine(
            WBSStore.dataTable.findIndex((dt) => dt.id == modelMapFirstRow.id),
            "description"
          );
          await this.fetchTakeOffIntoWBS(modelMap, ordernedList, false, false);
          toDelete.push(modelMapFirstRow.id);
        }
      } catch (e) {
        updateSuccessful = false;
        console.log(e);
      }
    }

    for (let i = 0; i < toDelete.length; i++) {
      await ToolbarStore.deleteWBSRowById(toDelete[i], true, false);
    }

    // // Se todas as inserções do model map antigo foram atualizadas com sucesso, remove o warning
    if (updateSuccessful) {
      WBSStore.loadDatatableWithRightFormat(WBSStore.WBSRows);
      WBSStore.setSelectedLine(
        WBSStore.dataTable.findIndex(
          (dt) =>
            dt.data.rowIndex === selectedRowIndex &&
            dt.data.parentStage == selectedParentStage
        ),
        "description"
      );
      // modelMap.data.warning = false; //

      let dataCurrentModelMap = await firebase
        .firestore()
        .collection("modelMaps")
        .doc(modelMap.id)
        .get();

      if (dataCurrentModelMap.exists) {
        let modelMapData = dataCurrentModelMap.data();
        if (modelMapData != undefined) {
          modelMap.data.costPlans = modelMapData.costPlans;
          modelMap.data.costPlansNeedtoBeUpdated =
            modelMapData.costPlansNeedtoBeUpdated;
        }
      }
      const list_ = WBSStore.dataTable.filter(
        (element) =>
          element.data.fromModelMap == modelMap.id &&
          element.data.rowType === ERowType.STAGE
      );
      let newActions = this.calculateModelMapFullChield(list_, dados_);

      await ModelMapStore.updateModelMap(modelMap);
      await WBSStore.batchActions(newActions, false);
    }
    TakeOffStore.statusModelmap = "Finished";
  }

  /**
   * Obtém o index do item formatado do takeOff que foi vinculado
   * a linha da EAP, usando como comparativo o "caminho" do item.
   * Exemplo1: quando o item não tem agrupador.
   *  Item 01
   *  Item 02
   * A lista takeOffPath com o caminho para obter o Item 02 ficaria ["Item 02"].
   *
   * Exemplo2: quando o item tiver um ou mais agrupadores.
   *  Grupo A
   *    Item 01
   *  Grupo B
   *    Item 01
   *    Item 02
   * A lista takeOffPath com o caminho para obter o Grupo B > Item 01 ficaria ["Item 01", "Grupo B"].
   * @param takeOffPath Caminho do item a ser buscado
   * @param {TakeOffFormatedItem[]} takeOffFormatedList Lista de itens formatados do model-map
   * @returns {number} Index do item ou -1 caso não tenha sido encontrado
   */
  private getTakeOffLineIndexByDescriptions(
    takeOffPath: string[],
    takeOffFormatedList: TakeOffFormatedItem[]
  ): number {
    if (!takeOffPath || takeOffPath.length === 0) return -1;

    // Se o item NÃO tiver agrupador, só procurá-lo pela lista
    if (takeOffPath.length === 1) {
      return takeOffFormatedList.findIndex(
        (t) => t.description === takeOffPath[0]
      );
    }

    // Se o item tiver agrupador, deve-se comparar as descrições
    // dos agrupadores também
    const filteredList = takeOffFormatedList.filter(
      (t) => t.description === takeOffPath[0]
    );

    for (const item of filteredList) {
      const isLinkedItem = compareTakeOffPath(item);
      if (isLinkedItem) {
        return item.listIndex || item.listIndex === 0 ? item.listIndex : -1;
      }
    }

    return -1;

    function compareTakeOffPath(itemToCompare: TakeOffFormatedItem): boolean {
      for (let i = 1; i < takeOffPath.length; i++) {
        const parentItem = takeOffFormatedList[itemToCompare.parentListIndex];
        if (parentItem && parentItem.description === takeOffPath[i]) {
          itemToCompare = parentItem;
        } else {
          return false;
        }
      }
      return true;
    }
  }

  private calculateModelMapFullChield(newStateList, oldStates) {
    let actions = new Array();
    let rowsToCalc = new Array();
    const globalBDI = WBSStore.WBS.data.bdi.percentual;
    const rules = WBSPropertiesStore.getRules(2);
    let sumTotal = 0;
    let sumTotalBdi = 0;
    for (let index = 0; index < newStateList.length; index++) {
      rowsToCalc.push(
        WBSStore.dataTable.filter(
          (element) => element.data.parentStage == newStateList[index].id
        )
      );
      let totalRowsToCalc = 0;
      let totalBdiRowsToCalc = 0;
      for (let i = 0; i < rowsToCalc[index].length; i++) {
        const bdiValue =
          rowsToCalc[index][i].data.bdi === undefined
            ? globalBDI
            : rowsToCalc[index][i].data.bdi;
        const result = CalculateWBSService.calculateRowBdi(
          rowsToCalc[index][i].data,
          rowsToCalc[index][i].data.total,
          bdiValue,
          WBSPropertiesStore.getRules()
        );

        rowsToCalc[index][i].data.totalBdi = result ? result.totalSale : 0;
        rowsToCalc[index][i].data.vendaBdi = result ? result.unitCostSale : 0;
        totalRowsToCalc = sum(
          totalRowsToCalc,
          rowsToCalc[index][i].data.total,
          rules
        );
        totalBdiRowsToCalc = sum(
          totalBdiRowsToCalc,
          rowsToCalc[index][i].data.totalBdi,
          rules
        );

        let rowsRef = WBSStore.WBSRef.collection("rows").doc(
          rowsToCalc[index][i].id
        );
        actions.push({
          type: "update",
          args: [
            rowsRef,
            {
              totalBdi: rowsToCalc[index][i].data.totalBdi,
              vendaBdi: rowsToCalc[index][i].data.vendaBdi,
            },
          ],
        });
      }

      sumTotal = sum(sumTotal, totalRowsToCalc, rules);
      sumTotalBdi = sum(sumTotalBdi, totalBdiRowsToCalc, rules);

      newStateList[index].data.total = sum(
        newStateList[index].data.total,
        totalRowsToCalc,
        rules
      );
      newStateList[index].data.totalBdi = sum(
        newStateList[index].data.totalBdi,
        totalBdiRowsToCalc,
        rules
      );

      let rowsRef = WBSStore.WBSRef.collection("rows").doc(
        newStateList[index].id
      );
      actions.push({
        type: "update",
        args: [
          rowsRef,
          {
            total: newStateList[index].data.total,
            totalBdi: newStateList[index].data.totalBdi,
          },
        ],
      });

      if (newStateList[index].data.parentStage != -1) {
        let resp = this.recursiveStageCalculate(newStateList[index]);
        actions.push(...resp);
      }
    }
    WBSStore.currentWbsTotalSaleCost = sum(
      WBSStore.currentWbsTotalSaleCost,
      sumTotalBdi,
      rules
    );
    WBSStore.currentWbsTotalCost = sum(
      WBSStore.currentWbsTotalCost,
      sumTotal,
      rules
    );
    actions.push({
      type: "update",
      args: [
        WBSStore.WBSRef,
        {
          totalCost: WBSStore.currentWbsTotalCost,
          totalSale: WBSStore.currentWbsTotalSaleCost,
        },
      ],
    });
    return actions;
  }

  recursiveStageCalculate(stage, actions_?, diffTotal_?, diffTotalBdi_?) {
    // Está dando erro quando deve repetir o valor de uma subietapa na sua etapa pai,
    // testar um jeito correto para fazer o diferencial(Que é o valor do ModelMapFull) e passar somente ele para cima
    let actions = actions_ ? actions_ : new Array();
    let diffTotal = diffTotal_ ? diffTotal_ : stage.data.total;
    let diffTotalBdi = diffTotalBdi_ ? diffTotalBdi_ : stage.data.totalBdi;
    const rules = WBSPropertiesStore.getRules(2);
    let stage_ = WBSStore.dataTable.find(
      (etapa) => etapa.id === stage.data.parentStage
    );
    let rowsRef, total, totalBdi;
    if (stage_ != null) {
      stage_.data.total = sum(stage_.data.total || 0, diffTotal, rules);
      stage_.data.totalBdi = sum(
        stage_.data.totalBdi || 0,
        diffTotalBdi,
        rules
      );
      total = stage_.data.total;
      totalBdi = stage_.data.totalBdi;
      rowsRef = WBSStore.WBSRef.collection("rows").doc(stage_.id);
      if (stage_.data.parentStage !== -1) {
        this.recursiveStageCalculate(stage_, actions, diffTotal, diffTotalBdi);
      }
    }
    actions.push({
      type: "update",
      args: [rowsRef, { total: total, totalBdi: totalBdi }],
    });
    return actions;
  }

  async addCostPlain(modelMapId) {
    let costPlans: any[] = [];
    let modelMapFirestore = await firestore
      .collection("modelMaps")
      .doc(modelMapId)
      .get();
    let modelMapData = modelMapFirestore.data();
    if (modelMapData) {
      costPlans.push(WBSStore.currentWbsId);
      if (modelMapData.costPlans) {
        for (let i = 0; i < modelMapData.costPlans.length; i++) {
          if (costPlans[i] != modelMapData.costPlans[i]) {
            costPlans.push(modelMapData.costPlans[i]);
          }
        }
        await firestore.collection("modelMaps").doc(modelMapId).update({
          costPlans: costPlans,
        });
      }
    }
  }

  async fetchTakeOffIntoWBS(
    modelMap: FirebaseDocument<ModelMap>,
    ordenedListTmp?,
    hasLoad = true,
    updateRowIndex = true
  ): Promise<void> {
    if (WBSStore.selectedLine.data.modelMapFull) {
      let idx = ToolbarStore.findModelMapMainLineIndex(WBSStore.selectedLine);
      await WBSStore.setSelectedLine(idx);
    }

    if (modelMap.data.formats) {
      if (modelMap.data.formats.length > 0) {
        this.addCostPlain(modelMap.id);
      }
    }

    let selectedLine = WBSStore.selectedLine;

    let idsRef: any = [];
    let contextsRef: any = [];

    if (
      selectedLine.index === -1 ||
      WBSStore.task ||
      WBSStore.displayCostPlan === "hidden"
    )
      return;

    if (
      modelMap.data.formats === undefined ||
      modelMap.data.formats.length === 0
    ) {
      ProjectStore.showSnackMessage(
        i18n.modelMaps.menuLateral.noFormatDefined,
        i18n.modelMaps.menuLateral.noFormatDefined2
      );
      return;
    }

    try {
      if (hasLoad) TakeOffStore.statusModelmap = "Loading";

      let ordernedList = ordenedListTmp
          ? ordenedListTmp
          : await this.getordernedList(modelMap.id),
        actions = new Array();

      // Primeira linha do Model Map
      let defaultRow = WBSModels.getDefaultRow({
        description: modelMap.data.name,
        rowIndex: selectedLine.data.rowIndex,
        rowType: ERowType.STAGE,
        quantity: 1,
        total: 0,
      });

      defaultRow.parentStage = selectedLine.data.parentStage;
      defaultRow.modelMapFull = true;
      defaultRow.fromModelMap = modelMap.id;

      let selectedRowRef: any = undefined;
      let selectedRowRefId: any = undefined;

      if (selectedLine.data.rowType == ERowType.BLANK) {
        selectedRowRef = WBSStore.WBSRef.collection("rows").doc(
          selectedLine.id
        );
        idsRef.push({ id: selectedRowRef.id, index: -1 });
        selectedRowRefId = selectedRowRef.id;
        WBSStore.changeAllArray({ ...defaultRow }, selectedLine, false);
        actions.push({
          type: "update",
          args: [selectedRowRef, defaultRow],
        });
      } else {
        if (updateRowIndex) {
          // Puxa as linhas para baixo
          actions.push(
            ...ToolbarStore.changeRowIndex(
              selectedLine.data.rowIndex,
              selectedLine.data.parentStage
            )
          );
        }

        selectedRowRef = WBSStore.WBSRef.collection("rows").doc();
        selectedRowRefId = selectedRowRef.id;
        idsRef.push({ id: selectedRowRef.id, index: -1 });
        WBSStore.WBSRows[WBSStore.WBSRows.length] = {
          data: { ...defaultRow },
          id: selectedRowRef.id,
          WBSRowsIndex: WBSStore.WBSRows.length,
        };
        actions.push({
          type: "set",
          args: [selectedRowRef, defaultRow],
        });
      }
      let total = 0;
      for (let i = 0; i < ordernedList.length; i++) {
        const element = ordernedList[i];

        let rowIndex = ordernedList.filter(
          (o) =>
            o.parentListIndex == element.parentListIndex &&
            o.listIndex < element.listIndex
        ).length;
        let idsRefIdx = idsRef.findIndex(
          (i) => i.index == element.parentListIndex
        );
        if (idsRefIdx == -1) continue;

        let defaultRowChildren = WBSModels.getDefaultRow({
          description: element.description,
          rowIndex: rowIndex,
          rowType: element.isStage ? ERowType.STAGE : ERowType.RESOURCE,
          quantity: element.resultQuantity,
          total: 0,
          unit: element.unit == "" ? undefined : element.unit,
        });

        // Variavel para descobrir se já existe na EAP
        let alreadExist: any = undefined;
        let indexDt = WBSStore.dataTable.findIndex((dt) => {
          return (
            ((element.isStage == true && dt.data.rowType == ERowType.STAGE) ||
              (element.isStage == false &&
                dt.data.rowType != ERowType.STAGE)) &&
            dt.data.rowType != ERowType.BLANK &&
            dt.data.fromModelMap == modelMap.id &&
            dt.data.modelMapFull == true &&
            dt.data.modelMapDescription == element.description
          );
        });
        if (indexDt > -1) {
          alreadExist = WBSStore.dataTable[indexDt];
        }

        defaultRowChildren.parentStage = idsRef[idsRefIdx].id;
        defaultRowChildren.modelMapFull = true;
        defaultRowChildren.fromModelMap = modelMap.id;
        defaultRowChildren.modelMapDescription = element.description;
        selectedRowRef = WBSStore.WBSRef.collection("rows").doc();
        idsRef.push({ id: selectedRowRef.id, index: element.listIndex });

        if (alreadExist && element.isStage == false) {
          const rules = WBSPropertiesStore.getRules(2);
          defaultRowChildren.total = times(
            alreadExist.data.unitCost,
            defaultRowChildren.quantity,
            rules
          );
          defaultRowChildren.unitCost = alreadExist.data.unitCost;
          defaultRowChildren.contentId = alreadExist.data.contentId;
          defaultRowChildren.description = alreadExist.data.description;
          defaultRowChildren.unit = alreadExist.data.unit;
          ToolbarStore.copyWBSRow(alreadExist);
          ToolbarStore.pasteWBSRow(undefined, defaultRowChildren);
          total = sum(total, alreadExist.data.total, rules);
        } else {
          if (element.isStage == true && alreadExist) {
            defaultRowChildren.total = alreadExist.data.total;
          }
          if (!element.isStage) {
            // Verifica se já foi adicionado anteriormente o mesmo item
            let contextsRefIdx = contextsRef.findIndex(
              (c) =>
                c.description == defaultRowChildren.description &&
                c.unit == defaultRowChildren.unit
            );

            // Se não encontrou cria o item na variavel temporária
            if (contextsRefIdx == -1) {
              contextsRef.push({
                contextId: defaultRowChildren.contentId,
                description: defaultRowChildren.description,
                unit: defaultRowChildren.unit,
              });
            } else {
              // Se já foi criado anteriormente, apenas copia seu resultado
              defaultRowChildren.contentId =
                contextsRef[contextsRefIdx].contextId;
            }
          }
          WBSStore.WBSRows[WBSStore.WBSRows.length] = {
            data: { ...defaultRowChildren },
            id: selectedRowRef.id,
            WBSRowsIndex: WBSStore.WBSRows.length,
          };
          actions.push({
            type: "set",
            args: [selectedRowRef, defaultRowChildren],
          });
        }
      }

      if (total > 0) {
        let newData: any = WBSStore.recursiveUpdateWBSSubcollection(
          undefined,
          total,
          undefined,
          selectedRowRefId
        );
        actions.push(...newData);
      }
      await WBSStore.batchActions(actions, false, () => {
        WBSStore.loadDatatableWithRightFormat(WBSStore.WBSRows);
        if (hasLoad) TakeOffStore.statusModelmap = "Finished";
        WBSStore.setSelectedLine(selectedLine.index, "description");
      });
    } catch (e) {
      console.log(e);
      if (hasLoad) TakeOffStore.statusModelmap = "Finished";
    }
  }

  private loadTakeOffStoreCollections(
    itemsArray: TakeOffItem[],
    columnsArray: any[]
  ) {
    let takeOffFilteredItems: any[] = [];
    let takeOffFilteredItemsFinal: any[] = [];
    if (
      TakeOffStore.takeOffModelMap !== undefined &&
      TakeOffStore.takeOffModelMap.data.filters
    ) {
      const itemsArrayCompare = itemsArray.map((el) => {
        const propertiesNames = Object.keys(el.properties);
        let propExist = propertiesNames.filter(
          (ell) =>
            ell ==
            ((TakeOffStore.takeOffModelMap &&
              TakeOffStore.takeOffModelMap.data.filters &&
              TakeOffStore.takeOffModelMap.data.filters[0] &&
              TakeOffStore.takeOffModelMap.data.filters[0].field) ||
              undefined)
        );
        if (propExist.length > 0) return propExist;
        return false;
      });
      let itemsArrayCompareKey = new Array();
      itemsArrayCompare.forEach((el, index) => {
        if (el == false) {
          itemsArrayCompareKey.push(index);
        }
      });
      for (let index = itemsArrayCompareKey.length - 1; index >= 0; index--) {
        itemsArrayCompare.splice(itemsArrayCompareKey[index], 1);
      }
      if (itemsArrayCompare.length > 0) {
        if (TakeOffStore.takeOffModelMap.data.filters.length > 0) {
          takeOffFilteredItems = this.applyFilter(
            TakeOffStore.takeOffModelMap.data.filters,
            itemsArray
          );

          takeOffFilteredItemsFinal = takeOffFilteredItems;
        } else {
          takeOffFilteredItemsFinal = itemsArray;
        }
      } else {
        if (takeOffFilteredItems.length == 0) {
          if (TakeOffStore.takeOffModelMap) {
            TakeOffStore.takeOffModelMap.data.filters = [];
          }
          TakeOffStore.takeOffModelMap.data.filterErrors = [];
          TakeOffStore.clearTakeOffModelMap();
          ModelMapStore.saveFilters([], true);
        }
        takeOffFilteredItemsFinal = itemsArray;
      }
    }

    TakeOffStore.setPrimaryTakeOffItens(
      itemsArray,
      columnsArray,
      takeOffFilteredItemsFinal,
      TakeOffStore.takeOffModelMap
    );
  }

  /**
   * Aplica o filtro informado nos itens do takeOff passados por parâmetro.
   * @param {ModelMapFilter[]} filters Filtros a serem aplicados nos itens do takeOff
   * @param {TakeOffItem} takeOffItems Itens do takeOff que serão filtrados
   * @returns {TakeOffItem[]} Itens do takeOff filtrados
   */
  applyFilter(
    filters: Array<ModelMapFilter>,
    takeOffItems: TakeOffItem[] = []
  ): TakeOffItem[] {
    if (filters.length === 0) {
      return takeOffItems;
    }

    const thisRef = this;
    let takeOffFilteredItems = _.filter(takeOffItems, function (item) {
      const materialsNames = Object.keys(item.materials);
      const propertiesNames = Object.keys(item.properties);
      const properties = item.properties;
      let itemIsValid = true;

      let indexOfFilters = 0;
      while (indexOfFilters < filters.length && itemIsValid) {
        const filter = filters[indexOfFilters];
        const nextFilter = filters[indexOfFilters + 1];

        // Verifica se o campo existe,
        // se a operação for 'blank' ou 'notin' retorna verdadeiro (pois o valor é vazio)
        // se não retorna falso (pois um valor era esperado)
        const hasFilteredField =
          materialsNames.includes(filter.field) ||
          propertiesNames.includes(filter.field);
        if (!hasFilteredField)
          return filter.operation === "blank" || filter.operation === "notin";

        let propertyValue = "";
        if (properties[filter.field])
          propertyValue = properties[filter.field].value || "";

        const hasSecondFilter = nextFilter && filter.field === nextFilter.field;
        const isOrOperator =
          filter.logicalOperator === "or" ||
          (nextFilter && nextFilter.logicalOperator === "or");

        // Aplica filtro
        itemIsValid = thisRef.compareFilterAndValue(filter, propertyValue);
        // Se tiver uma segunda condição, teste-a
        if (hasSecondFilter && isOrOperator) {
          indexOfFilters++;
          if (!itemIsValid)
            itemIsValid = thisRef.compareFilterAndValue(
              nextFilter,
              propertyValue
            );
        }

        indexOfFilters++;
      }
      return itemIsValid;
    });
    if (takeOffFilteredItems.length == 0) {
      if (TakeOffStore.takeOffModelMap) {
        TakeOffStore.takeOffModelMap.data.filters = [];
      }
      return takeOffItems;
    }
    return takeOffFilteredItems;
  }

  /**
   * Compara o valor da propriedade passado com as regras do filtro verificando
   * se o mesmo é válido ou não.
   * @param {ModelMapFilter} filter Filtro usado na validaçao
   * @param {string} propertyValue Valor da propriedade a ser validado
   * @returns {booelan} Se o valor é valido ou não de acordo com as regras do filtro.
   */
  private compareFilterAndValue(
    filter: ModelMapFilter,
    propertyValue: string
  ): boolean {
    const propertyText = String(propertyValue || "").toLowerCase();
    const operationText = String(filter.operationValue || "").toLowerCase();

    let propertyNumber = extractNumberFromText(propertyValue),
      operationNumber;
    const isNumber = propertyNumber !== undefined;

    if (isNumber) {
      propertyNumber = roundBy(propertyNumber || 0, {
        decimalPlaces: 2,
        roundingRule: "round",
      });
    }

    switch (filter.operation) {
      case "in":
        return isNumber
          ? String(propertyNumber).indexOf(operationText) > -1
          : propertyText.indexOf(operationText) > -1;

      case "notin":
        return isNumber
          ? String(propertyNumber).indexOf(operationText) === -1
          : propertyText.indexOf(operationText) === -1;

      case "blank":
        return propertyText === "";

      case "filled":
        return propertyText !== "";

      case "==":
        if (isNumber) {
          operationNumber = extractNumberFromText(filter.operationValue);
          return propertyNumber === operationNumber;
        }
        return propertyText === operationText;

      case ">":
        operationNumber = extractNumberFromText(filter.operationValue);
        if (propertyNumber === undefined || operationNumber === undefined)
          return true;

        return propertyNumber > operationNumber;

      default:
        operationNumber = extractNumberFromText(filter.operationValue);
        if (propertyNumber === undefined || operationNumber === undefined)
          return true;

        return propertyNumber < operationNumber;
    }
  }

  /**
   * Método responsável por receber os dados brutos de um documento do firebase e retornar um objeto
   * do tipo TakeOffItem cvom as informações necessárias
   * @param data Conteúdo do documento fileItem do firebase
   * @param wbsId Id da WBS
   */
  private setTakeOffItem(data, wbsId) {
    // Ordena as propriedades
    let props = data.properties;
    const orderned = {};
    Object.keys(props)
      .sort()
      .forEach(function (key) {
        orderned[key] = props[key];
      });

    let modelMap = new TakeOffItem(
      data["GUID"],
      data["development"],
      data["file"],
      data["ifcLabel"],
      data["materials"],
      data["modelMapId"],
      data["name"],
      data["parentGUID"],
      orderned,
      data["type"],
      wbsId
    );
    return modelMap;
  }

  async getTakeOffData(modelMapId, description) {
    let snapshot = await firestore
      .collection("developments")
      .doc(DevelopmentStore.developmentId)
      .collection("takeOffFormatedItems")
      .where("modelMapId", "==", modelMapId)
      .where("description", "==", description)
      .get();
    if (snapshot.docs.length === 0) {
      return {
        error: {
          error: true,
          type: "File not found",
          message: "Arquivo não encontrado, verifique o Model Map.",
        },
        data: null,
      };
    }
    let data = snapshot.docs[0].data();
    return { error: { error: false, type: "", message: "" }, data: data };
  }

  async getTakeOffDataAll(modelMapId) {
    let snapshot = await firestore
      .collection("developments")
      .doc(DevelopmentStore.developmentId)
      .collection("takeOffFormatedItems")
      .where("modelMapId", "==", modelMapId)
      .get();
    if (snapshot.docs.length === 0) {
      return {
        error: {
          error: true,
          type: "File not found",
          message: "Arquivo não encontrado, verifique o Model Map.",
        },
        data: null,
      };
    }
    let data = snapshot.docs.map((d) => d.data());
    return { error: { error: false, type: "", message: "" }, data: data };
  }
}

function sleep(ms: number = 1000) {
  return new Promise((resolve) => {
    setTimeout(() => resolve(true), ms);
  });
}

let TakeOffService = new Service();
export { TakeOffService };



// WEBPACK FOOTER //
// ./src/modules/takeOff/TakeOffService.ts